import { NbToastrService } from '@nebular/theme';
import { ImagesService } from './../../apiclient/api/images.service';
import { Component, OnInit } from '@angular/core';
import { UserSessionService } from '../../UserSession/user-session.service';
import { CompanyService } from '../../apiclient';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import {Location} from '@angular/common';
import { LocalDataSource } from 'ng2-smart-table'; //Esther #146
import { IconPropertyFieldComponent } from './IconPropertyFieldComponent'; //Esther #146
import { IconPropertyRenderComponent } from './IconPropertyRenderComponent'; //Esther #146
import { MAIN_MENUS_BY_DEFAULT } from './../pages-menu';

/**
 * Componente que renderiza el editor de compañías
 */
@Component({
  selector: 'ngx-company-editor',
  templateUrl: './company-editor.component.html',
  styleUrls: ['./company-editor.component.scss']
})
export class CompanyEditorComponent implements OnInit {
  // Esther #146
  companyMenu = JSON.parse(JSON.stringify(MAIN_MENUS_BY_DEFAULT));

  // Esther #146
  settings = {
    actions: {
      delete: false,
      add: false,
      edit: true,
      position: 'right',
  },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
    },
    columns: {
       menu: {
        title: 'Menú',
        type: 'number',
        filter : false,
        editable : false,
      },
      title: {
        title: 'Título',
        type: 'string',
        filter : false,
      },
      icon: {
        title: 'Icono',
        type: 'custom',
        renderComponent:IconPropertyRenderComponent,
        editor: {
          type: 'custom',
          component: IconPropertyFieldComponent,
        },
        filter : false,
      },
    },
  };

  idcompany: string;
  source: LocalDataSource = new LocalDataSource();

  constructor(private userSessionService: UserSessionService,
    private companyService: CompanyService ,private route: ActivatedRoute,
    private imagesService: ImagesService,
    private sanitizer: DomSanitizer,
    private toastrService: NbToastrService,
    private location: Location) { }

    companydata: any = {}
    themefiles: any = {};
    themeimages: any = {
      dashboard_theme:{
        logoImage:'./assets/images/nopicture.png',
        backgroundImage:'./assets/images/nopicture.png',
      },
      mobile_theme:{
        logoImage:'./assets/images/nopicture.png',
        backgroundImage:'./assets/images/nopicture.png',
        splashImage:'./assets/images/nopicture.png',
      }
    };

    correspondenciasFilesImages = {
      'desktoplogo' : {theme: 'dashboard_theme', image: 'logoImage'},
      'desktopbackground' : {theme: 'dashboard_theme', image: 'backgroundImage'},
      'mobilelogo' : {theme: 'mobile_theme', image: 'logoImage'},
      'mobilebackground' : {theme: 'mobile_theme', image: 'backgroundImage'},
      'mobilesplash' : {theme: 'mobile_theme', image: 'splashImage'},

    }
    loading: boolean = false;

    /**
     * @ignore
     */
  ngOnInit(): void {

    this.route.paramMap.subscribe((params) => {
      console.log(params.get('company'));
      this.idcompany = params.get('company');
      if(this.idcompany != '0'){
        this.companyService.getCompany(+this.idcompany,this.userSessionService.accessToken).subscribe((data)=>{
          this.companydata = data;
          // Esther #146
          if(this.companydata.theme_configuration.dashboard_menu == null || this.companydata.theme_configuration.dashboard_menu == undefined){
            this.companydata.theme_configuration.dashboard_menu = [];
          }
          this.companydata.theme_configuration.dashboard_menu = Object.assign(this.companyMenu,this.companydata.theme_configuration.dashboard_menu); // Esther #146
          this.source.load(this.companydata.theme_configuration.dashboard_menu); // Esther #146
          this.cargarImagenes()
        })
      }else{
        this.companydata = {theme_configuration:{}};
        this.themefiles = {};
        this.themeimages = {
      dashboard_theme:{
        logoImage:'./assets/images/nopicture.png',
        backgroundImage:'./assets/images/nopicture.png',
      },
      mobile_theme:{
        logoImage:'./assets/images/nopicture.png',
        backgroundImage:'./assets/images/nopicture.png',
        splashImage:'./assets/images/nopicture.png',
      }
    };

    this.companydata.theme_configuration.dashboard_menu = JSON.parse(JSON.stringify(this.companyMenu)); // Esther #146
    this.source.load(this.companydata.theme_configuration.dashboard_menu); // Esther #146
      }



    });
  }

  /**
   * Carga las imágenes de la compañía
   */
  cargarImagenes(): void {

    console.log(this.themeimages);
    console.log("Obteniendo imagenes");
    if (typeof this.companydata.theme_configuration.dashboard_theme != 'undefined'){
      if(typeof this.companydata.theme_configuration.dashboard_theme.logoImage != 'undefined'){
        this.imagesService.imageImagepathGet(this.companydata.theme_configuration.dashboard_theme.logoImage,
          this.userSessionService.accessToken).subscribe((data) => {
              console.log(data);
              this.themeimages.dashboard_theme.logoImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
          });
      }

      if(typeof this.companydata.theme_configuration.dashboard_theme.backgroundImage != 'undefined'){
        this.imagesService.imageImagepathGet(this.companydata.theme_configuration.dashboard_theme.backgroundImage,
          this.userSessionService.accessToken).subscribe((data) => {
              console.log(data);
              this.themeimages.dashboard_theme.backgroundImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
          });
      }
    }

    if (typeof this.companydata.theme_configuration.mobile_theme != 'undefined'){
      if(typeof this.companydata.theme_configuration.mobile_theme.logoImage != 'undefined'){
        this.imagesService.imageImagepathGet(this.companydata.theme_configuration.mobile_theme.logoImage,
          this.userSessionService.accessToken).subscribe((data) => {
              console.log(data);
              this.themeimages.mobile_theme.logoImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
          });
      }

      if(typeof this.companydata.theme_configuration.mobile_theme.backgroundImage != 'undefined'){
        this.imagesService.imageImagepathGet(this.companydata.theme_configuration.mobile_theme.backgroundImage,
          this.userSessionService.accessToken).subscribe((data) => {
              console.log(data);
              this.themeimages.mobile_theme.backgroundImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
          });
      }

      if(typeof this.companydata.theme_configuration.mobile_theme.splashImage != 'undefined'){
        this.imagesService.imageImagepathGet(this.companydata.theme_configuration.mobile_theme.splashImage,
          this.userSessionService.accessToken).subscribe((data) => {
              console.log(data);
              this.themeimages.mobile_theme.splashImage = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
          });
      }
    }
  }

  /**
   * Guarda la compañía
   */
  guardar(): void{
    console.log("Guardando compañía");

    console.log(this.themefiles);
    this.loading = true;



    if(this.idcompany != '0'){


      //EDICION


      this.companyService.editcompany(+this.idcompany,JSON.stringify(this.cleanData(this.companydata)),this.userSessionService.accessToken,
      this.themefiles.mobilelogo,
      this.themefiles.mobilesplash,
      this.themefiles.mobilebackground,
      this.themefiles.desktoplogo,
      this.themefiles.desktopbackground).subscribe((resultado) => {
        //SE acutaliza la compañía
        this.loading = false;
        this.companydata = resultado;
        console.log(resultado);
        this.toastrService.success('Guardado con éxito','Guardar')
      })
    }else{
      //NNUEVA

      console.log("Creamos la compañia "+ JSON.stringify(this.companydata))
      this.companyService.newcompany(JSON.stringify(this.companydata),this.userSessionService.accessToken,
      this.themefiles.mobilelogo,this.themefiles.mobilesplash,
      this.themefiles.mobilebackground,
      this.themefiles.desktoplogo,this.themefiles.desktopbackground).subscribe((resultado) => {
        //SE crea la compañía
        console.log(resultado);
        this.companydata = resultado;
        this.userSessionService.refreshCompanyCache();
        this.idcompany = this.companydata.id;
        this.loading = false;
        this.toastrService.success('Guardado con éxito','Guardar')
      })
    }

  }



  /**
   * Actualzia la imagen
   * @param nombre Nombre de la imagen a actualizar
   * @param archivos Archivo
   */
  actualizarArchivo(nombre: string,archivos: FileList){

    this.themefiles[nombre] = archivos.item(0);
    var imagesConfig = this.correspondenciasFilesImages[nombre];
    console.log(imagesConfig);
    this.themeimages[imagesConfig.theme][imagesConfig.image] = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(archivos.item(0)));

  }

  /**
   * Regresa a la página anterior
   */
  back(): void{
    this.location.back()
  }

  /**
   * @ignore
   * @param o
   * @returns
   */
  cleanData(o: any): any {
    if (Object.prototype.toString.call(o) == "[object Array]") {
      for (let key = 0; key < o.length; key++) {
        this.cleanData(o[key]);
        if(Object.prototype.toString.call(o[key]) == "[object Object]") {
          if(Object.keys(o[key]).length === 0){
            o.splice(key, 1);
            key--;
          }
        }

      }
    }
    else if (Object.prototype.toString.call(o) == "[object Object]") {
      for (let key in o) {
        let value = this.cleanData(o[key]);
        if (value === null) {
          delete o[key];
        }
        if(Object.prototype.toString.call(o[key]) == "[object Object]") {
          if(Object.keys(o[key]).length === 0){
            delete o[key];
          }
        }
        if(Object.prototype.toString.call(o[key]) == "[object Array]") {
          if(o[key].length === 0){
            delete o[key];
          }
        }
      }
    }
    return o;
  }
}
